import activatePopupComponent from './activatePopup.component';

const activatePopupModule = angular.module('app.components.clinicalData.subjects.activatePopup', [])
	.component('activatePopup', activatePopupComponent)
	.name;

export default activatePopupModule;
